export default __webpack_public_path__ + "static/media/certif.23d8008a.svg";